import { makeStyles, fade } from '@material-ui/core/styles';

const drawerWidth = 0;

export default makeStyles((theme) => ({
  appBar: {
    boxShadow: '0 8px 24px rgba(232, 72, 79, 0.18)',
    background: 'linear-gradient(90deg, #FF8A75 0%, #FF6B6B 55%, #E8484F 100%)',
    color: 'var(--color-white)',
    paddingBottom: '0.4rem',
    paddingTop: '0.4rem',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  title: {
    flexGrow: 1,
    alignItems: 'center',
    display: 'flex',
    textDecoration: 'none',
    color: 'var(--color-white)',
    [theme.breakpoints.up('sm')]: {
      minWidth: '200px',
    },
  },
  image: {
    padding: '4px',
    transition: 'transform .2s ease',
    '&:hover': {
      transform: 'scale(1.04) rotate(-1deg)',
    },
  },
  brand: {
    fontFamily: 'Fraunces, serif',
    fontSize: '1.7rem',
    fontWeight: 700,
    color: 'var(--color-white)',
    letterSpacing: '-0.01em',
    transition: 'transform .2s ease',
    '&:hover': {
      transform: 'translateY(-1px)',
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  grow: {
    flexGrow: 1,
  },
  search: {
    position: 'relative',
    borderRadius: '999px',
    backgroundColor: 'rgba(255, 255, 255, 0.22)',
    border: '1.5px solid rgba(255, 255, 255, 0.35)',
    transition: 'all .2s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.32)',
    },
    '&:focus-within': {
      backgroundColor: '#fff',
      borderColor: '#fff',
      boxShadow: '0 0 0 4px rgba(255, 255, 255, 0.25)',
      '& $searchIcon': {
        color: 'var(--color-coral)',
      },
      '& input': {
        color: 'var(--color-plum)',
      },
      '& input::placeholder': {
        color: 'var(--color-text-soft)',
      },
    },
    marginLeft: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--color-white)',
    transition: 'color .2s ease',
  },
  searchInput: {
    '& > input': {
      color: 'var(--color-white)',
      padding: theme.spacing(1.1, 1.5, 1.1, 0),
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      fontFamily: 'Inter, sans-serif',
      fontSize: '0.95rem',
      transition: theme.transitions.create('width'),
      '&::placeholder': {
        color: 'rgba(255, 255, 255, 0.85)',
        opacity: 1,
      },
      [theme.breakpoints.up('xs')]: {
        width: '5rem',
        '&:focus': {
          width: '7rem',
        },
      },
      [theme.breakpoints.up('sm')]: {
        width: '14ch',
        '&:focus': {
          width: '22ch',
        },
      },
    },
  },
  header: {
    padding: '0.75rem 1rem',
    fontSize: '0.9rem',
    boxShadow: 'none',
    background: 'var(--gradient-festive)',
    textAlign: 'center',
    color: 'var(--color-white)',
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    '& > *': {
      color: 'var(--color-white)',
    },
  },
  menu: {
    paddingTop: '3rem',
    backgroundColor: 'var(--color-cream)',
    height: '100%',
    minWidth: '260px',
  },
  menuItem: {
    fontFamily: 'Fraunces, serif',
    fontSize: '1.35rem',
    fontWeight: 500,
    padding: '1.25rem 2.5rem',
    color: 'var(--color-plum)',
    transition: 'all .18s ease-in-out',
    position: 'relative',
    '&:hover': {
      backgroundColor: 'var(--color-pink-blush)',
      color: 'var(--color-coral)',
      paddingLeft: '3rem',
    },
  },
}));
